var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-danger btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.reset()}}},[_c('li',{staticClass:"fa fa-recycle"}),_vm._v(" SZCS#GPS_DISSLP=0\n")])}
var staticRenderFns = []

export { render, staticRenderFns }